








































































































import { Component, Vue } from 'nuxt-property-decorator'
import PageSeoMixin from '~/mixins/PageSeoMixin'
import SectionLead from '~/components/Section/SectionLead.vue'
import SectionContentAligned from '~/components/Section/SectionContentAligned.vue'
import Parallax from '~/components/_common/Parallax.vue'
import '~/assets/styles/macbook.css'

@Component({
  name: 'TranslationInIQubePage',
  components: {
    SectionLead,
    SectionContentAligned,
    Parallax,
    VueAgile: process.client
      ? () => import('vue-agile').then(({ VueAgile }) => VueAgile)
      : { inheritAttrs: false, render: (h) => h('span', null) }
  },
  mixins: [PageSeoMixin]
})
export default class extends Vue {
  get slides() {
    const list = [
      { Img: '1_Glossary_+_Number_Checks.PNG' },
      { Img: '2_Glossary_Opposite_terms.PNG' },
      { Img: '3_Language_rules_+_Glossary_+_Verification.PNG' },
      { Img: '4_QA_reviewer.PNG' }
    ]
    return list.map((item) => {
      const image = require(`~/assets/img/translation-in-iqube/carousel/${item.Img}`)
      // `background-image:url(${image})`
      return {
        ...item,
        Image: image,
        Style: {
          // backgroundImage: `url(${image})`,
          // backgroundPosition: item.Position,
          // height: `${this.carouselHeight}px`,
          // backgroundSize: 'cover'
        }
      }
    })
  }
}
